import { useCallback, useContext, useState } from 'react';
import { ServiceContext } from '../../context/ServiceContext';

export function useAuth(): {
  isAuthenticated: boolean;
} {
  const { authService } = useContext(ServiceContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const isAuthenticatedCallback = useCallback(async () => {
    const response = await authService.isAuthenticated();
    setIsAuthenticated(response);
  }, [authService]);

  isAuthenticatedCallback();
  return {
    isAuthenticated,
  };
}
